/**
 * wgs84 地心坐标系 GPS原始知坐标体系。在中国，任何一个地图产品都不允许使用GPS坐标，据说是为了保密。GoogleEarth及GPS芯片使用
 * bd09 百度
 * gcj02 火星坐标系 高德、腾讯、Google中国地图使用
 */
var locationUtils = {};

let PI = 3.14159265358979324
let x_pi = PI * 3000.0 / 180.0;
function transformLat (x, y) {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
  return ret
}
function transformLon (x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
  return ret
}
function locationDelta (lon, lat) {
  let a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
  let ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
  let dLat = transformLat(lon - 105.0, lat - 35.0)
  let dLon = transformLon(lon - 105.0, lat - 35.0)
  let radLat = lat / 180.0 * PI
  let magic = Math.sin(radLat)
  magic = 1 - ee * magic * magic
  let sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI)
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI)
  return [dLon, dLat]
}

locationUtils.gcj02Towgs84 = function (lng, lat) {
   let a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
  let ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
   lat = +lat;
   lng = +lng;
  let dlat = transformLat(lng - 105.0, lat - 35.0);
  let dlng = transformLon(lng - 105.0, lat - 35.0);
  let radlat = lat / 180.0 * PI;
  let magic = Math.sin(radlat);
  magic = 1 - ee * magic * magic;
  let sqrtmagic = Math.sqrt(magic);
  dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
  dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
  let mglat = lat + dlat;
  let mglng = lng + dlng;
  return [lng * 2 - mglng, lat * 2 - mglat]
}

locationUtils.gcj02Tobd09 = function (lon, lat) {
  let x = lon
  let y = lat
  let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
  let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
  let bdLon = z * Math.cos(theta) + 0.0065
  let bdLat = z * Math.sin(theta) + 0.006
  return [bdLon, bdLat]
}

locationUtils.bd09Towgs84 = function (lng, lat) {
  let bd09ToGcj02Location = locationUtils.bd09Togcj02(lng, lat)
  let gcj02towgs84Location =  locationUtils.gcj02Towgs84(bd09ToGcj02Location[0], bd09ToGcj02Location[1])

  return gcj02towgs84Location
}
  
locationUtils.bd09Togcj02 = function(bdLon, bdLat) {
  let x = bdLon - 0.0065
  let y = bdLat - 0.006
  let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
  let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  let gcjLon = z * Math.cos(theta);
  let gcjLat = z * Math.sin(theta)
  return [gcjLon, gcjLat]
}

locationUtils.wgs84Togcj02 = function (lon, lat) {
   lat = +lat;
   lon = +lon;
  let d = locationDelta(lon, lat);
  return [lon + d[0], lat + d[1]]
}
locationUtils.wgs84Tobd09 = function (lon, lat) {
   lat = +lat;
   lon = +lon;
  let gcj02 = locationUtils.wgs84Togcj02(lon, lat)
  return locationUtils.gcj02Tobd09(gcj02[0], gcj02[1])
}
export default locationUtils;